import { getMessage } from '@common/constants/locale';
import { localeSelector } from '@common/redux/selectors/language';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useSelector } from 'react-redux';

/**
 * Shown instead of the app when the visitor's IP is not on the app's
 * allow-list (MIK-4882).
 *
 * Rendered before any app content loads, so it deliberately depends on nothing
 * but the app's own locale.
 */
const IpRestricted = () => {
  const locale = useSelector(localeSelector);

  return (
    <View style={styles.container}>
      <View style={styles.card}>
        <Text style={styles.title}>
          {getMessage({ id: 'ipRestriction.blocked.title', locale })}
        </Text>
        <Text style={styles.body}>
          {getMessage({ id: 'ipRestriction.blocked.description', locale })}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f5f5',
    padding: 24,
  },
  card: {
    maxWidth: 520,
    width: '100%',
    backgroundColor: '#ffffff',
    borderRadius: 8,
    paddingVertical: 32,
    paddingHorizontal: 28,
  },
  title: {
    fontSize: 20,
    fontWeight: '600',
    color: '#1f1f1f',
    marginBottom: 16,
  },
  body: {
    fontSize: 14,
    lineHeight: 22,
    color: '#434343',
  },
});

export default IpRestricted;
